module.exports = __webpack_public_path__ + "media/nicole3.6dc55ce4.mp3";